var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg th ba b--light-gray",style:(_vm.backgroundStyle)},[_c('flat-pickr',{attrs:{"config":_vm.config,"value":_vm.value},on:{"input":function($event){_vm.onDateChange($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }